import { ContentEntityApi } from './content.api-model';
import { Content } from './content.vm';

export const mapContentFromApiToVm = (content: ContentEntityApi): Content => ({
  id: content.id,
  title: content.title,
  type: content.type,
  completed: content.completed,
  content: content.content,
  src: content.file?.url,
  points: content.points,
  order: content.order,
  routeId: content.routeId,
  subtitles: content.subtitles,
  duration: content.duration,
  lastVisitedAt: content.lastVisitedAt,
  visitCount: content.visitCount,
  contentInteractionId: content.contentInteractionId,
  quizData: content.quizData,
  quizResponses: content.quizResponses,
  stageId: content.stageId,
  overviewData: content.overviewData,
  analysisPrompt: content.analysisPrompt,
  hasAnalysisPrompt: content.hasAnalysisPrompt,
});

export const mapContentCollectionFromApiToVm = (contents: ContentEntityApi[]): Content[] =>
  contents.map(mapContentFromApiToVm);
